/* UTILS */
import restTypes from 'utils/rest/types';
import restStates from 'utils/rest/states';
import restInitState from 'utils/rest/initState';

/* TYPES */
import {
  SET_CUSTOMER_FIELD,
  SET_CUSTOMER_FIELDS,
  SET_CUSTOMER_EDIT_MODE,
  FETCH_AGENTS_START,
  FETCH_AGENTS_FINISHED,
  CLEAR_CUSTOMER_DATA,
} from 'actions/types';

const initialState = {
  list: [],
  agents: [],
  fields: {},
  changedFields: {},
  fieldsUpdated: false,
  editMode: false,
  claims: {
    list: [],
  },
  documents: [],
  lastUploadedDocument: {},
  hasErrors: false,
  errors: {},
};

const customerRestTypes = restTypes('customer');

const {
  fetchAllStart,
  fetchAllFinished,
  fetchOneStart,
  fetchOneFinished,
  deleteStart,
  deleteFinished,
  updateStart,
  updateFinished,
  createStart,
  createFinished,
} = customerRestTypes;

const customer = (
  state = { ...restInitState, ...initialState },
  action = {},
) => {
  switch (action.type) {
    case fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };

    case fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        list: action.payload.users
          ? action.payload.users
          : action.payload.result,
        pageCurrent: action.payload.meta && action.payload.meta.currentPage,
        pagesTotal: action.payload.meta && action.payload.meta.totalPages,
      };

    case fetchOneStart:
      return {
        ...state,
        ...restStates.fetchOneStart,
      };

    case fetchOneFinished:
      return {
        ...state,
        ...restStates.fetchOneFinished,
        data: action.payload,
      };

    case deleteStart:
      return {
        ...state,
        ...restStates.deleteStart,
        ...action.payload,
      };

    case deleteFinished:
      return {
        ...state,
        ...restStates.deleteFinished,
        ...action.payload,
      };

    case updateStart:
      return {
        ...state,
        ...restStates.updateStart,
        ...action.payload,
      };

    case updateFinished:
      return {
        ...state,
        ...restStates.updateFinished,
        data: action.payload,
      };

    case createStart:
      return {
        ...state,
        ...restStates.createStart,
        hasErrors: false,
        errors: {},
      };

    case createFinished:
      return {
        ...state,
        ...restStates.createFinished,
        data: action.payload,
        hasErrors: action?.payload?.hasErrors,
        errors: action?.payload?.errors,
      };

    case SET_CUSTOMER_FIELD:
      return {
        ...state,
        fields: {
          ...state.fields,
          [action.payload.name]: action.payload.value,
        },
        changedFields: {
          ...state.changedFields,
          [action.payload.name]: action.payload.value,
        },
      };

    case SET_CUSTOMER_FIELDS:
      return {
        ...state,
        fields: action.payload,
        fieldsUpdated: true,
      };

    case SET_CUSTOMER_EDIT_MODE:
      return {
        ...state,
        editMode: action.payload,
      };

    case FETCH_AGENTS_START:
      return {
        ...state,
        fetchingAgents: true,
        fetchedAgents: false,
      };

    case FETCH_AGENTS_FINISHED:
      return {
        ...state,
        fetchingAgents: false,
        fetchedAgents: true,
        agents: action.payload,
      };

    case CLEAR_CUSTOMER_DATA:
      return {
        ...state,
        data: {},
        fields: {},
      };

    default:
      return state;
  }
};

export default customer;
